import { render, staticRenderFns } from "./Page401.vue?vue&type=template&id=b420a4ca&"
import script from "./Page401.vue?vue&type=script&lang=js&"
export * from "./Page401.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports